module.exports = __webpack_public_path__ + "static/img/pete_pictgrid21_1060x868.9edd943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid21_1060x868.jpg
// module id = u+pz
// module chunks = 0